import * as React from 'react';

import './AiBotIcon.css';

const AiBotIcon = ({isAnimated = false, fillColor = '#2961fa'}) =>
  isAnimated ? (
    <AnimatedBotIcon fillColor={fillColor} />
  ) : (
    <BotIcon fillColor={fillColor} />
  );

const AnimatedBotIcon = ({fillColor}) => {
  const starConfigs = [
    {
      className: 'et-abi-animated-bot-icon-star-top-left',
      delay: '0s',
    },
    {
      className: 'et-abi-animated-bot-icon-star-top-right',
      delay: '0.75s',
    },
    {
      className: 'et-abi-animated-bot-icon-star-bottom-left',
      delay: '1.5s',
    },
    {
      className: 'et-abi-animated-bot-icon-star-bottom-right',
      delay: '2.25s',
    },
  ];

  return (
    <div className="et-abi-animated-bot-icon-wrap">
      <BotIcon fillColor={fillColor} />
      {starConfigs.map((starConfig, idx) => (
        <div key={idx} className="et-abi-animated-bot-icon-star-container">
          <div
            className={`et-abi-animated-bot-icon-star-wrap ${starConfig.className}`}
            style={{animationDelay: starConfig.delay}}>
            <div className="et-abi-animated-bot-star-icon">
              <StarIcon fillColor={fillColor} />
            </div>
          </div>{' '}
        </div>
      ))}
    </div>
  );
};

const BotIcon = ({fillColor}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={12} height={16}>
      <path
        fill={fillColor}
        d="M8.589 8.925H2.972A2.106 2.106 0 0 1 .866 6.819V4.01a2.106 2.106 0 0 1 2.106-2.106H8.59a2.106 2.106 0 0 1 2.106 2.106V6.82a2.106 2.106 0 0 1-2.106 2.106ZM2.972 3.308a.702.702 0 0 0-.702.702V6.82a.702.702 0 0 0 .702.702H8.59a.702.702 0 0 0 .702-.702V4.01a.702.702 0 0 0-.702-.702H2.972Z"
      />
      <path
        fill={fillColor}
        d="M4.376 6.117a.737.737 0 0 1-.714-.6.702.702 0 0 1 .848-.804c.046.006.091.02.133.042a.393.393 0 0 1 .12.063l.112.084a.702.702 0 0 1-.499 1.215ZM7.185 6.116a.702.702 0 0 1-.27-1.353.705.705 0 0 1 .768 1.15.703.703 0 0 1-.112.084.393.393 0 0 1-.12.063.421.421 0 0 1-.133.042l-.133.014ZM5.78 2.606a.702.702 0 0 1-.702-.702v-.702a.702.702 0 1 1 1.404 0v.702a.702.702 0 0 1-.702.702ZM3.674 15.243a.702.702 0 0 1-.702-.702v-2.107a.702.702 0 0 1 1.405 0v2.107a.702.702 0 0 1-.703.702ZM7.887 15.243a.702.702 0 0 1-.702-.702v-2.107a.702.702 0 0 1 1.404 0v2.107a.702.702 0 0 1-.702.702Z"
      />
      <path
        fill={fillColor}
        d="M7.887 13.136H3.674a.702.702 0 0 1-.702-.702V8.222a.702.702 0 0 1 .702-.702h4.213a.702.702 0 0 1 .702.702v4.212a.702.702 0 0 1-.702.702Zm-3.51-1.404h2.808V8.924H4.377v2.808Z"
      />
      <path
        fill={fillColor}
        d="M.866 11.732a.702.702 0 0 1-.316-1.327l2.808-1.404a.702.702 0 1 1 .632 1.25l-2.808 1.404a.653.653 0 0 1-.316.077ZM10.695 11.732a.653.653 0 0 1-.316-.077L7.571 10.25A.702.702 0 1 1 8.203 9l2.808 1.404a.702.702 0 0 1-.316 1.327Z"
      />
    </svg>
  );
};

const StarIcon = ({fillColor}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={7}
      height={6}
      fill={fillColor}>
      <path
        fill={fillColor}
        d="M2.494 3.936 3.43 6l.935-2.064L6.43 3l-2.065-.936L3.43 0l-.936 2.064L.43 3l2.064.936Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1={1.363}
          x2={3.621}
          y1={-0.14}
          y2={4.964}
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#2961FA" />
          <stop offset={1} stopColor="#2D2756" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default AiBotIcon;
